<template>
<div class="SpecialList padding-20 bgc box-shadow">
    <div class="filters">
        <div class="add">
            <el-button type="primary" @click="handleCancel">返回上级</el-button>
        </div>
        <div class="search"></div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="examcode" label="考试代码" min-width="120px" class-name="title"></el-table-column>
            <el-table-column prop="examname" label="考试名称" min-width="450px" class-name="title">
                <template slot-scope="scope">{{scope.row.examname}}</template>
            </el-table-column>
            <el-table-column label="操作" min-width="200px" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <span class="separator-btn">
                            <el-button @click.stop="handleBankSetting(scope.row)" type="text" size="small">题库设置</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click.stop="handleDataManage(scope.row)" type="text" size="small">数据管理</el-button>
                        </span>
                        <!-- <span class="separator-btn">
                            <el-button @click.stop="handleSetting(scope.row)" type="text" size="small">题库设置</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click.stop="handleMgt(scope.row)" type="text" size="small">内容管理</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click.stop="handleData(scope.row)" type="text" size="small">数据管理</el-button>
                        </span> -->
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <specialSettingDialog ref="specialSettingDialog"></specialSettingDialog>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getAllQuestionbanktopicinfo} from 'api/questionApi'
import SpecialSettingDialog from 'views/cms/special/components/specialSettingDialog.vue'
export default {
    name: 'SpecialList',
    data() {
        return {
            tableData: [],
            param: {}
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        handleSetting(row) {
            this.$refs.specialSettingDialog.openDialog(row)
        },
        // 题库设置
        handleBankSetting(row) {
            this.$router.push({name: 'BankSetting', query: {examcode: row.examcode}})
        },
        // 数据管理
        handleDataManage(row) {
            this.$router.push({name: 'DataManage', query: {examcode: row.examcode}})
        },
        handleMgt(row) {
            this.$router.push({ name: 'SpecialMgt', query: {examcode:row.examcode, examname: row.examname}})
        },
        handleData(row) {
            this.$router.push({name: 'SpecialData', query: {examcode:row.examcode, examname: row.examname}})
        },
        handleCancel() {
            this.$router.back()
        },
        _getList() {
            this.setLoading(true)
            getAllQuestionbanktopicinfo({
                data: Object.assign({}, this.param),
                success: data => {
                    this.tableData = data.data.content
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        SpecialSettingDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.SpecialList {
}
</style>
